import { render, staticRenderFns } from "./CampaignCreateInstagramConfirm.vue?vue&type=template&id=22414160&scoped=true"
import script from "./CampaignCreateInstagramConfirm.vue?vue&type=script&lang=ts"
export * from "./CampaignCreateInstagramConfirm.vue?vue&type=script&lang=ts"
import style0 from "./CampaignCreateInstagramConfirm.vue?vue&type=style&index=0&id=22414160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22414160",
  null
  
)

export default component.exports